import { render, staticRenderFns } from "./skeletonAuthSSO.vue?vue&type=template&id=4e2a32a0&scoped=true"
import script from "./skeletonAuthSSO.vue?vue&type=script&lang=js"
export * from "./skeletonAuthSSO.vue?vue&type=script&lang=js"
import style0 from "./skeletonAuthSSO.vue?vue&type=style&index=0&id=4e2a32a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2a32a0",
  null
  
)

export default component.exports